import { format } from 'date-fns'
export function datetime(v, fmt) {
    if (typeof v === 'number' || v instanceof Date) return format(v, fmt)
    if (typeof v === 'string') return format(new Date(v), fmt)
    return ''
}
